import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import HotFormulasContent from './components/HotFormulasContent';

export default function HotFormulasPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '熱銷配方｜17+ 保健食品配方・多元劑型選擇｜康永生技',
    description: '康永生技提供 17+ 保健食品熱銷配方：美肌、女性私密、男性魅力、順暢輕盈、水潤晶亮等，1,000+ 代工品項、7 大劑型可選。',
    keywords: '熱銷配方,保健食品配方,17種配方,劑型選擇,ODM配方設計,保健食品市場',
    lang: 'zh-TW',
    canonicalPath: '/services/hot-formulas',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="熱銷配方｜17+ 保健食品配方・多元劑型選擇｜康永生技" pageDescription="康永生技提供 17+ 保健食品熱銷配方：美肌、女性私密、男性魅力、順暢輕盈、水潤晶亮等，1,000+ 代工品項、7 大劑型可選。" pageUrl={`${siteUrl}/services/hot-formulas`} />
      <HotFormulasContent />
    </Layout>
  );
}